//https://stackoverflow.com/questions/175739/built-in-way-in-javascript-to-check-if-a-string-is-a-valid-number
function isNumeric(variable:any, ){
    return !isNaN(variable)
}

export default isNumeric;